var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3088 37.0449C23.6551 38.0503 22.4886 38.7549 21.009 38.7549C19.5125 38.7549 18.3456 38.048 17.6975 37.0449H24.3088ZM21.009 4.68359C22.7671 4.68359 24.116 5.90466 24.6292 7.70801L24.8391 8.44824L25.5637 8.70898C29.3139 10.0573 31.0432 13.7977 31.1809 20.4238L31.1829 20.4844C31.2461 21.5233 31.3621 22.7508 31.6301 23.9014C31.8899 25.0166 32.3368 26.2615 33.1965 27.1602L33.2024 27.166L33.2073 27.1719C34.0298 28.0134 34.7573 28.7026 35.3254 29.4277C35.8919 30.1508 36.0852 30.6543 36.0852 31.0273C36.0852 31.2392 36.0196 31.335 35.9329 31.4062C35.8164 31.5019 35.5219 31.6542 34.9309 31.6543H7.06958C6.49077 31.6543 6.19318 31.5037 6.07153 31.4043C5.979 31.3287 5.91533 31.2312 5.91528 31.0283C5.91528 30.6584 6.10934 30.1559 6.67993 29.4297C7.2533 28.7 7.97549 28.015 8.79517 27.167L8.79614 27.168C9.67125 26.2666 10.1185 25.0162 10.3782 23.9014C10.6459 22.7521 10.7619 21.5249 10.8333 20.4961L10.8362 20.458V20.4199C10.9568 13.8001 12.7028 10.056 16.4377 8.70801L17.1545 8.44922L17.3684 7.71875C17.8999 5.90129 19.2361 4.68359 21.009 4.68359Z",
    stroke: "#006EC2",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures6);
export default __webpack_public_path__ + "static/media/features6.b330ad815d32fd4f665a2757a812cb97.svg";
export { ForwardRef as ReactComponent };